// extracted by mini-css-extract-plugin
module.exports = {"imgUrl":"RejectModal_imgUrl__1Yghu","unitInfo":"RejectModal_unitInfo__own_E","fields":"RejectModal_fields__QLqdd","colItem":"RejectModal_colItem__1EfV_"};